/**
 * @generated SignedSource<<790eb214efb5d3244f0af270d83990cc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "total",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "routes_VehicleRentalStation_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "VehicleRentalStation",
        "kind": "LinkedField",
        "name": "vehicleRentalStation",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "VehicleRentalStationContent_vehicleRentalStation"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "QueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "routes_VehicleRentalStation_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "VehicleRentalStation",
        "kind": "LinkedField",
        "name": "vehicleRentalStation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lat",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lon",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RentalVehicleEntityCounts",
            "kind": "LinkedField",
            "name": "availableVehicles",
            "plural": false,
            "selections": (v2/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RentalVehicleEntityCounts",
            "kind": "LinkedField",
            "name": "availableSpaces",
            "plural": false,
            "selections": (v2/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "capacity",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "VehicleRentalNetwork",
            "kind": "LinkedField",
            "name": "rentalNetwork",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "networkId",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "stationId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "operative",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e80b29693b09e55a46eb9758989a6a05",
    "id": null,
    "metadata": {},
    "name": "routes_VehicleRentalStation_Query",
    "operationKind": "query",
    "text": "query routes_VehicleRentalStation_Query(\n  $id: String!\n) {\n  vehicleRentalStation(id: $id) {\n    ...VehicleRentalStationContent_vehicleRentalStation\n    id\n  }\n}\n\nfragment VehicleRentalStationContent_vehicleRentalStation on VehicleRentalStation {\n  lat\n  lon\n  name\n  availableVehicles {\n    total\n  }\n  availableSpaces {\n    total\n  }\n  capacity\n  rentalNetwork {\n    networkId\n  }\n  stationId\n  operative\n}\n"
  }
};
})();

node.hash = "8117d0a6a181e5f0566e67b6473709f8";

export default node;
